<!-- MODALE SHARE -->
<div>
    <div class="container-general-share">
        <div class="container-general-share__container-header bg-support-99">
            <div
                class="container-general-share__container-header__top-bar d-flex justify-content-between align-items-center text-uppercase">
                <div class="col-1"></div>
                <p class="col-10 ls-label-medium-semibold text-uppercase text-support-40 text-center m-0"
                    id="modal-basic-title">
                    {{"MODAL_SHARE.SEND_TO" | translate}}
                </p>
                <div class="col-1 close cursor-pointer text-center" [attr.aria-label]="'Close'" (click)="closeModal()">
                    <i class="fa-solid fa-plus text-support-40" style="transform: rotate(45deg);" aria-hidden="true"></i>
                </div>
            </div>
        </div>
        <div class="container-general-share__container-body d-flex flex-wrap justify-content-center">
            <a class="container-general-share__container-body__item" (click)="openToast()">
                <div>
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/copy-link.png" alt="copy link icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">
                        {{"MODAL_SHARE.COPY_LINK" | translate}}
                    </p>
                </div>
            </a>
            <a class="container-general-share__container-body__item"
                onclick="javascript:window.location='mailto:?body=' + window.location">
                <div>
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/email.png" alt="email icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">email</p>
                </div>
            </a>
            <a class="container-general-share__container-body__item">
                <div (click)="printDocument()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/print.png" alt="print icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">
                        {{"MODAL_SHARE.PRINT" | translate}}
                    </p>
                </div>
            </a>
            <a class="container-general-share__container-body__item" [href]="fromParent.facebook" target="_blank">
                <div>
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/facebook.png" alt="facebook icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">facebook</p>
                </div>
            </a>
            <a class="container-general-share__container-body__item" [href]="fromParent.twitter" target="_blank">
                <div>
                    <img loading="lazy" src="./assets/images/share-icon/x.png" alt="twitter icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">x</p>
                </div>
            </a>
            <a class="container-general-share__container-body__item" [href]="fromParent.linkedin" target="_blank">
                <div>
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/linkedin.png" alt="linkedin icon">
                    <p class="pt-3 text-brand-10 ls-label-medium-semibold text-uppercase">linkedin</p>
                </div>
            </a>
        </div>
    </div>
</div>
<!-- END MODALE SHARE -->
<!-- TOAST -->
<div *ngIf="isOpenToast" class="toast-container position-absolute bottom-50 start-0 p-3">
    <div id="liveToast" role="alert" aria-live="assertive" aria-atomic="true">
        <!-- <div class="toast-header">
            <strong class="me-auto">{{"MODAL_SHARE.COPIED" | translate}}</strong>
        </div> -->
        <div class="toast-body">
            {{"MODAL_SHARE.COPIED" | translate}}
        </div>
    </div>
</div>